namespace TabAurous.Common {
    export enum StoneStatus {
        Ok = 1,
        Broken = 2,
        Missing = 3
    }
    Serenity.Decorators.registerEnumType(StoneStatus, 'TabAurous.Common.StoneStatus', 'Fixed.StoneStatus');
}
